import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Grid } from 'images/latest'

const GridIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='18px'
    height='18px'
    className='unstyled grid-icon'
    color={color}
    SVG={Grid}
  />
)

export default GridIcon
